export default `#ifdef GL_ES
precision highp float;
precision highp int;
#endif

#include <common>
#include <clipping_planes_pars_vertex>

uniform sampler2D texture1;
uniform bool displayClasses;

uniform float pointScale;
uniform bool attenuation;

uniform float screenHeight;

attribute float classification;
attribute float point_size;

varying float vClassification;
varying vec4 vColor;
varying vec3 vNormal;

float attenuationScale(float zPosition) {
  bool isPerspective = (projectionMatrix[2][3] == -1.0);
  if (isPerspective && attenuation) {
    float far = projectionMatrix[3][2] / (projectionMatrix[2][2] + 1.0);
    float distanceFactor = 25.0;
    return (far / (-zPosition * distanceFactor));
  }
  if (attenuation) {
    
    return projectionMatrix[1][1] * screenHeight * 0.5;
  }
  return 1.0;
}

float resolveCullOffset(float classOpacity) {
  return displayClasses ? 999999.0 * (1.0 - classOpacity) : 0.0;
}

void main() {
  vClassification = classification;
  vColor = vec4(color.rgb, 1.0);
  vNormal = vec3(normal);

  vec4 texture = texture2D(texture1, vec2(vClassification / 67.0, 0.0));

  vec3 transformed = position;
  transformed.x += resolveCullOffset(texture.a);

  vec4 mvPosition = modelViewMatrix * vec4(transformed, 1.0);
  gl_Position = projectionMatrix * mvPosition;

  if (attenuation) {
    gl_PointSize = point_size * attenuationScale(mvPosition.z) * pointScale;
  } else {
    gl_PointSize = pointScale;
  }

  #include <worldpos_vertex>
  #include <clipping_planes_vertex>
}`